import { render, staticRenderFns } from "./SupervisionPendingBanner.vue?vue&type=template&id=1690a3c7&scoped=true&"
import script from "./SupervisionPendingBanner.vue?vue&type=script&lang=js&"
export * from "./SupervisionPendingBanner.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionPendingBanner.vue?vue&type=style&index=0&id=1690a3c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1690a3c7",
  null
  
)

export default component.exports